/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Rounding_PlatesInputs */

const en_us2_workout_logging_rounding_plates = /** @type {(inputs: Workout_Logging_Rounding_PlatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plates`)
};

const pt_br2_workout_logging_rounding_plates = /** @type {(inputs: Workout_Logging_Rounding_PlatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anilhas`)
};

const es_419_workout_logging_rounding_plates = /** @type {(inputs: Workout_Logging_Rounding_PlatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discos`)
};

const pt_pt2_workout_logging_rounding_plates = /** @type {(inputs: Workout_Logging_Rounding_PlatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discos`)
};

const fr_fr2_workout_logging_rounding_plates = /** @type {(inputs: Workout_Logging_Rounding_PlatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disques`)
};

const de_de2_workout_logging_rounding_plates = /** @type {(inputs: Workout_Logging_Rounding_PlatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheiben`)
};

const it_it2_workout_logging_rounding_plates = /** @type {(inputs: Workout_Logging_Rounding_PlatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dischi`)
};

/**
* | output |
* | --- |
* | "Plates" |
*
* @param {Workout_Logging_Rounding_PlatesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_rounding_plates = /** @type {((inputs?: Workout_Logging_Rounding_PlatesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Rounding_PlatesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_rounding_plates(inputs)
	if (locale === "es-419") return es_419_workout_logging_rounding_plates(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_rounding_plates(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_rounding_plates(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_rounding_plates(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_rounding_plates(inputs)
	return en_us2_workout_logging_rounding_plates(inputs)
});
export { workout_logging_rounding_plates as "workout-logging.rounding_plates" }